<template>
  <div 
    class="__card_double" 
    :class="fullWidth ? 'full-width' : ''"
  >
    <div class="__card_double_left">
      <slot name="left"></slot>
    </div>
    <div class="__card_double_right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
};
</script>


<style lang="scss">
.__card_double {
  width: 100%;
  max-width: 960px;

  margin: auto;

  background: #ffffff;
  box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08),
    0px 8px 12px -8px rgba(0, 0, 0, 0.16);
  border-radius: 8px;

  display: flex;
  flex-direction: row;
  padding: 24px;

  &.full-width {
    max-width: 100%;
  }

  &_left {
    width: 50%;
  }

  &_right {
    width: 50%;
  }
}
</style>